import React, { useState, useEffect } from "react";
import affiliate_api from "../../api/affiliates";
import auth from "../../api/auth";
import GenericDialog from "../../components/GenericDialog";

const Affiliates = () => {
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogText, setDialogText] = useState("");
    const buttons = [{ text: "OK", id: "1" }];

    useEffect(() => {
        auth.hasSession().then((session) => {
            if (!session) window.location.assign("/logout");
        });
    }, []);

    const downloadAffiliateCSV = () => {
        affiliate_api.getAffiliateTracking()
            .then((resp) => {
                const data = resp.data.data;       // base64 string
                const filename = resp.data.filename || "affiliate_tracking.csv";

                const base64_link = "data:text/csv;base64," + data;
                const anchor = document.createElement("a");
                anchor.href = base64_link;
                anchor.download = filename;
                anchor.click();
            })
            .catch(() => {
                setDialogTitle("Fetching Error");
                setDialogText("There was an error getting the affiliate data. Please try again.");
            });
    };

    const handleErrorDialogResult = (res) => {
        if (!res) return;
        setDialogText("");
        setDialogTitle("");
    };

    return (
        <div className="page-container">
            <div className="page-title">Affiliates</div>
            <div className="button link" onClick={downloadAffiliateCSV}>
                Download Affiliate Tracking CSV
            </div>
            {dialogText && (
                <GenericDialog
                    title={dialogTitle}
                    text={dialogText}
                    buttons={buttons}
                    result={handleErrorDialogResult}
                />
            )}
        </div>
    );
};

export default Affiliates;
